import axios from "axios";

export default axios.create({
    baseURL: "https://a63e-2405-4802-30-3520-2508-601d-2dd3-3752.ngrok-free.app",
    withCredentials: true,
});
